import React from 'react'
import { useSelector } from 'react-redux'
import { FormattedMessage, defineMessages } from 'react-intl'

// Utils
import { useFormatMessage } from 'src/providers/intl'
import history from 'src/history'

// Components
import { Text, Button, ConfettiTarget } from 'src/Components'

// Selectors
import { selectCustomerFirstName } from 'src/store/selectors/customerProfile'

// Assets
import instantOfferConfirmGifSource from './instant-offer-confirm.gif'

// Styles
import styles from './InstantOfferConfirmationPanel.module.scss'

const messages = defineMessages({
  gifAlt: {
    id: 'Homeowner.instantOffer.confirmation.gif',
    defaultMessage: 'Instant Offer',
  },
})

const InstantOfferConfirmationPanel = () => {
  const intlFormat = useFormatMessage()
  const customerfirstName = useSelector(selectCustomerFirstName)
  const handleClick = () => {
    history.goBack()
  }

  return (
    <ConfettiTarget className={styles.confetti} numberOfPieces={150}>
      <div className={styles.panelWrapper}>
        <div className={styles.contentWrap}>
          <img
            className={styles.image}
            src={instantOfferConfirmGifSource}
            alt={intlFormat(messages.gifAlt)}
          />
          <Text
            size='xxl'
            align='center'
            variant='neutralCool'
            variantCount='900'
            className={styles.header}
          >
            <FormattedMessage
              id='Homeowner.instantOffer.confirmation.header'
              defaultMessage='Nice!'
            />
          </Text>
          <Text
            size='m'
            align='center'
            variant='neutralCool'
            variantCount='700'
          >
            <FormattedMessage
              id='Homeowner.instantOffer.confirmation.description'
              defaultMessage='{customerfirstName} will be in touch shortly to guide you through your options'
              values={{ customerfirstName }}
            />
          </Text>
        </div>
        <div className={styles.buttonWrap}>
          <Button className={styles.button} onClick={handleClick}>
            <FormattedMessage
              id='Homeowner.instantOffer.confirmation.button'
              defaultMessage='Return to Dashboard'
            />
          </Button>
        </div>
      </div>
    </ConfettiTarget>
  )
}

export default InstantOfferConfirmationPanel
